import React from 'react'
import location from "../../assets/images/location.png"

function Spinner() {
  return (
    <div className="main-load">
      <div className="spinner dotted"></div>
    </div>
  )
}

export default Spinner;